<template>
  <section
      class="container overflow-hidden relative mb-20 border-b border-bw-08 pb-20"
      v-if="dataRender && dataRender.length > 0"
  >
    <div class="flex flex-col lg:flex-row lg:gap-8">
      <nuxt-link
          data-aos="fade-right"
          data-aos-once="true"
          @click="removeAttribute(firstItem)"
          :to="firstItem?.url"
          class="flex flex-col lg:border-none border-b lg:pb-0 pb-8 border-bw-08 flex-1 group removeAnimationFeature"
      >
        <div class="aspect-178/120 w-full rounded-15px overflow-hidden mb-6">
          <img
              :src="getThumbnail(firstItem?.thumbnail?.id, 715, true)"
              :alt="firstItem?.thumbnail?.description || firstItem?.thumbnail?.title"
              class="w-full h-full object-cover transfrom group-hover:scale-105 duration-300"
          />
        </div>
        <div class="flex-1">
          <p class="flex gap-2 uppercase divide-x divide-bw-04 text-bw-04 text-13px leading-6 font-semibold">
            {{ firstItem?.category?.title }}
          </p>

          <p class="leading-6 text-lg font-[550] text-black mb-2 group-hover:text-primary duration-400">
            {{ firstItem?.title }}
          </p>
          <p class="text-black/60 mt-6 lg:block hidden">
            {{ firstItem?.intro }}
          </p>
        </div>
      </nuxt-link>
      <div class="lg:w-108 lg:pl-8 lg:border-l border-bw-08">
        <h4
            data-aos="fade-left"
            data-aos-once="true"
            class="font-semibold leading-6 text-15px text-primary uppercase pb-6 border-b border-bw-08 lg:block hidden"
        >
          {{ t('LATEST') }}
        </h4>
        <div class="flex flex-col gap-8 divide-y-1 divide-bw-08">
          <GlobalItemListNew
              data-aos="fade-left"
              data-aos-once="true"
              @click="removeAttribute(news)"
              v-for="news in remainningData"
              :dataItem="news"
              :key="news?.id"
              class="pt-8 removeAnimationFeature"
          ></GlobalItemListNew>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
export default {
  name: 'sectionNewList'
}
</script>

<script setup lang="ts">
import {ref, computed} from 'vue'
import {
  NEWS_EVENT_ID,
  useEventTracking
} from "../../../composables/ackee/event";

const {getListing} = useIZNewsListing()
const {t} = useI18n()

const removeAttribute = (firstItem: any) => {
  useEventTracking(NEWS_EVENT_ID, `${firstItem?.category?.title} - ${firstItem?.title}`)

  document.querySelectorAll('.removeAnimationFeature').forEach((item) => {
    item.removeAttribute('data-aos')
  })
}

const route = useRoute()
// const _slugCategory = route.params.id.split('-').pop()
const _slugCategory = route.params.slug

const dataRender = ref([])
const res = await getListing(route.params.langCode, {slug: _slugCategory, query: {page: 1, limit: 5}})

dataRender.value = res.on_top

const firstItem = computed(() => {
  return dataRender.value[0] ?? {}
})

const remainningData = computed(() => {
  return dataRender.value.slice(1)
})
</script>

<style></style>
